import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { InmunoterapiaProxima } from './InmunoterapiaProxima';
import { InmunoterapiaPrevia } from './InmunoterapiaPrevia';
import { Forbidden } from '../../../components';

import styles from '../PacienteConsulta.module.css';

export const Inmunoterapia = () => {

    let { id } = useParams();

    const { permisos } = useSelector(state => state.auth);

    let defaultTab = 3;

    if(permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete){
        defaultTab = 1;
    }

    const [tab, setTab] = useState(defaultTab);

    return (
        <>
            <div className="row">
                <div className="col">
                    <div className={styles.tabsSubHeader}>Inmunoterapia</div>
                    <div  className={styles.tabsContainerInner + " mt-3"}>
                        <div className={"row"}>
                            {(permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 1) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(1)}>Actuales</div>
                            </div>
                            }
                            {(permisos.inmunoterapiaRead) &&
                            <div className="col p-0 text-center">
                                <div className={ (tab === 2) ? styles.tabActiveInner : styles.tabInner } onClick={() => setTab(2)}>Previas</div>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={styles.tabsContentContainerInner}>
                        { ((permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && tab === 1) && <InmunoterapiaProxima id={id} /> }
                        { (permisos.inmunoterapiaRead && tab === 2) && <InmunoterapiaPrevia id={id} /> }
                        { (tab === 3) && <Forbidden /> }
                    </div>
                </div>
            </div>
        </>
    )
}
